// extracted by mini-css-extract-plugin
module.exports = {"tabWrap":"agency-info-component_tabWrap__IA6Dr","infoItems":"agency-info-component_infoItems__2ppgq"};